import { t } from 'i18next'
import React, { Fragment } from 'react'
import { useColumnSearchSalesOrder } from './hooks/useColumnSearchSalesOrder'
import Navigation from 'Components/Navigation'
import { TableSearchDocuments } from 'Components/TableSearchDocuments/TableSearchDocuments'
import { SearchSalesDocumentsProvider } from 'state/context/SearchSalesDocumentsContext'
import FilterSearchDocuments from 'Components/TableSearchDocuments/FiltersSearchDocuments/FilterSearchDocuments'
import SearchDocumentsNumberedPagination from 'Components/TableSearchDocuments/SearchDocumentsPagination/SearchDocumentsNumberedPagination'
import { searchSalesOrders } from 'redux/services/cotizacionServices'
import {
  salesOrderDocumentsSearchConfig,
  salesOrderFilterFields,
} from './searchSalesOrderDocuments.config'
import DispatchNumberPopover from 'Components/ActionTable/components/DispatchNumberPopover/DispatchNumberPopover'

const SalesOrderFilter = () => (
  <FilterSearchDocuments
    fields={salesOrderFilterFields}
    statusFilterKey="salesOrder"
    filterButtonTestId="btn-filter-sales-orders"
    clearButtonTestId="btn-clear-filters-sales-orders"
  />
)

function SearchSaleOrder() {
  const { columns, dispatchPopover, setDispatchPopover } =
    useColumnSearchSalesOrder()

  return (
    <SearchSalesDocumentsProvider
      fetcher={searchSalesOrders}
      initialFilters={salesOrderDocumentsSearchConfig.initialFilters}
      buildPayload={salesOrderDocumentsSearchConfig.buildPayload}>
      <Fragment>
        <Navigation />
        <section
          className="common-search-content"
          data-testid="container-search-sale-order">
          <header className="common-search-header">
            <h2>{t('SEARCH_QUOTATION_T.SALES_ORDER')}</h2>
          </header>
          <TableSearchDocuments
            columns={columns}
            FilterComponent={SalesOrderFilter}
            PaginationComponent={SearchDocumentsNumberedPagination}
          />
        </section>
        <DispatchNumberPopover
          props={{
            dispatchValue: dispatchPopover,
            setDispatchValue: setDispatchPopover,
          }}
        />
      </Fragment>
    </SearchSalesDocumentsProvider>
  )
}

export default SearchSaleOrder
